<template>
  <a-layout-sider
    v-model="collapsed"
    :class="navigationmode === 'fixed' ? 'fix-slider' : ''"
    :collapsedWidth="collapsedWidth"
    :style="{
      overflow: 'auto',
      'min-height': '100vh',
      position: navigationmode,
      left: 0,
      background: pagestyle === 'dark' ? '#101c2e' : '#fff'
    }"
    :trigger="null"
    :width="sliderWidth"
    class="own-slider"
    collapsible
  >
    <div
      :class="[pagestyle === 'light' ? 'light' : '']"
      :style="{ height: height + 'px' }"
      class="logo"
    >
      <router-link to="/">
        <div class="imgbox">
          <img alt="" src="~@/assets/image/logo-index.png" srcset="" />
        </div>
        <h1
          v-if="!collapsed"
          :style="{ color: pagestyle === 'light' ? themecolor : '#fff' }"
        >
          维特沃斯
        </h1>
      </router-link>
    </div>
    <Menu
      :style="{ height: `calc(100% - ${height}px)` }"
      :theme="pagestyle"
    ></Menu>
  </a-layout-sider>
</template>
<script>
import Menu from "../Menu"
import eventBus from "@/bus"
import { PageSetting } from "@/config"
import { mapGetters } from "vuex"

export default {
  components: { Menu },
  data() {
    return {
      collapsed: false,
      height: PageSetting.headerHeight,
      collapsedWidth: PageSetting.collapsedWidth,
      sliderWidth: PageSetting.sliderWidth
    }
  },
  computed: {
    ...mapGetters(["pagestyle", "navigationmode", "themecolor"])
  },
  beforeMount() {
    eventBus.$on("collapsed", val => {
      this.$nextTick(() => {
        this.collapsed = val
      })
    })
  },
  watch: {
    navigationmode(newVal) {
      console.log(newVal)
    }
  }
}
</script>
<style lang="scss" scoped>
.own-slider {
  min-height: 100vh;
  overflow-x: hidden !important;
  border-right: 1px solid rgba(226, 232, 240, 0.82);

  &.fix-slider {
    height: 100vh;
  }

  .logo {
    width: 100%;
    height: 64px;
    display: flex;
    position: relative;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    padding-left: 20px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.08),
      transparent
    );

    ::v-deep a {
      width: auto;
      display: flex;
      align-items: center;
    }

    .imgbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 10px;
      overflow: hidden;
      background: rgba(24, 144, 255, 0.08);
      flex-shrink: 0;

      img {
        display: block;
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }

    h1 {
      color: #fff;
      margin: 0 0 0 12px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
      vertical-align: middle;
      width: 120px;
      white-space: nowrap;
    }

    &.light {
      border-bottom: 1px solid #eef1f5;

      .imgbox {
        background: rgba(24, 144, 255, 0.1);
      }
    }
  }

  ::v-deep .ant-layout-sider-children {
    .ant-menu {
      overflow-y: auto;
      padding: 8px 0 16px;
      border-right: none !important;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .ant-menu-item,
      .ant-menu-submenu-title {
        margin: 2px 8px !important;
        width: calc(100% - 16px) !important;
        border-radius: 8px;
        height: 40px;
        line-height: 40px;
      }

      .ant-menu-item-selected {
        font-weight: 600;
        box-shadow: inset 3px 0 0 currentColor;
      }

      &.ant-menu-inline .ant-menu-item::after {
        display: none;
      }
    }
  }
}
</style>
